import { Component, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ExcelService } from 'src/app/service/excel.service';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { PlanVsActualService } from 'src/app/service/plan-vs-actual.service';

@Component({
  selector: 'app-plan-versus-actual-part-number',
  templateUrl: './plan-versus-actual-part-number.component.html',
  styleUrls: ['./plan-versus-actual-part-number.component.scss'],
  standalone: false
})
export class PlanVersusActualPartNumberComponent implements OnInit {

  gridApi: any;
  successMessage
  eventType
  errorMessage
  columnDefs = [];
  rowData = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  routeDate;
  route;
  shipmentsService: any;
  isAccessible: boolean;
  dock: any;
  plant: any;
  supplier: any;
  dynamicHeight: number;
  totalRecords = 0;
  sRecord = 1;
  eRecord = 1;
  cPage = 1;
  tPage = 0;
  rpPage: any = 30;
  endRecord = 0;
  pgDropDown = [
    { value: 5, selected: false },
    { value: 10, selected: false },
    { value: 20, selected: false },
    { value: 30, selected: true },
    { value: 50, selected: false },
  ];
  originalPage: any;
  paginationPageSize: number = 30;

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService: ExcelService, private readonly PlanVsActualService: PlanVsActualService, public datepipe: DatePipe,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private location: Location,
    private readonly eboiStateService: EboiStateService,) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }

    this.gridOptions = {
      suppressCellSelection: true,
      context: this.context,
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    //  this.checkRoles()  
    this.columnDefs = [

      {
        headerName: "Part#", field: "partNumber",
        wrapText: true,//autoHeight :true, minWidth : 70,maxWidth:70
      },
      {
        headerName: "Boxes", field: "boxes",
        wrapText: true,//autoHeight :true, minWidth : 70,maxWidth:70
      },
      {
        headerName: "OWK Boxes", field: "owkBoxes",
        wrapText: true,//autoHeight :true, minWidth : 100,maxWidth:100
      },
      {
        headerName: "Box Variance", field: "boxVariance",
        wrapText: true,//autoHeight :true, minWidth : 150,maxWidth:150
      },
      {
        headerName: "length", field: "length", autoHeight: true, wrapText: true,// minWidth : 70,maxWidth:70

      },
      {
        headerName: "Width", field: "width", autoHeight: true, wrapText: true//minWidth : 100,maxWidth:100

      },
      {
        headerName: "Height", field: "height", autoHeight: true, wrapText: true,// minWidth : 100,maxWidth:100

      },
      {
        headerName: "Part Weight", field: "partWeight", autoHeight: true, wrapText: true,

      },
      {
        headerName: "Dunnage Weight", field: "dunnageWeight",
        autoHeight: true, wrapText: true,
      },
      {
        headerName: "Packaging Weight", field: "packagingWeight", autoHeight: true, wrapText: true,

      },
      {
        headerName: "QPC", field: "qpc", autoHeight: true, wrapText: true// minWidth : 70,maxWidth:70
        // width: 400,
      },
      {
        headerName: "QPL", field: "qpl", autoHeight: true, wrapText: true//minWidth : 70,maxWidth:70
        // width: 400,
      },
      {
        headerName: "Stability Code", field: "stackabilityCode", autoHeight: true, wrapText: true// minWidth : 100,maxWidth:100
        // width: 400,
      },

    ];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.route = localStorage.getItem('route');
    this.routeDate = localStorage.getItem('routeDate');
    this.plant = JSON.parse(localStorage.getItem('supplier'));
    this.supplier = JSON.parse(localStorage.getItem('dock'));
    this.dock = JSON.parse(localStorage.getItem('part-number'));
    this.RefreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   this.openRouteLevel('home');
    // }
  }


  RefreshData() {
    if (this.dock) {
      this.displayRowData = []
      this.gridApi?.setGridOption('rowData', this.displayRowData);
      this.rowCount = this.displayRowData.length;
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      const updateObject = {
        p_RouteDate: this.datepipe.transform(this.routeDate, 'MM-dd-yyyy'),
        p_Route: this.route,
        p_Plant: this.plant,
        p_Supplier: this.supplier,
        p_Dock: this.dock,
      }
      this.PlanVsActualService.loadDock(updateObject).subscribe(
        response => {
          this.displayRowData = JSON.parse(response)
          this.gridApi?.setGridOption('rowData', this.displayRowData);
          this.rowCount = this.displayRowData.length;
          if (this.displayRowData.length) {
            this.totalRecords = this.displayRowData.length;
            this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
            this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
            this.sRecord = 1
            this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
            if (this.cPage > this.tPage) {
              this.cPage = 1;
            }
          }
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        },
        error => {
          console.info(error)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );

    }
    else {
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);
    }

  }




  onBtExport() {
    console.info(this.displayRowData?.length)
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
    if (this.displayRowData?.length > 0) {
      this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
      const exportData = [];
      this.displayRowData.forEach(e => {
        const obj = {
          Part_Number: e.partNumber,
          Boxes: e.boxes,
          OWK_Boxes: e.owkBoxes,
          Box_Variance: e.boxVariance,
          Length: e.length,
          Width: e.width,
          Height: e.height,
          Part_Weight: e.partWeight,
          Dunnage_Weight: e.dunnageWeight,
          Packaging_Weight: e.packagingWeight,
          QPC: e.qpc,
          QPL: e.qpl,
          Stackability_Code: e.stackabilityCode,
        };
        exportData.push(obj);
      });

      const headers = ['PART_NUMBER', 'BOXES', 'OWK_BOXES', 'BOX_VARIANCE', 'LENGTH', 'WIDTH', 'HEIGHT', 'PART_WEIGHT', 'DUNNAGE_WEIGHT',
        'PACKAGING_WEIGHT', 'QPC', 'QPL', 'STACKABILITY_CODE'];
      this.excelService.exportAsExcelFile(exportData, 'PART-NUMBER-DATA', headers);
      this.ngxUiLoaderService.stop(this.constants.LoaderInitializer)

    }
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); this.updatePaginationDetails(); }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

  goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));
    }
    else {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    }
  }

  updatePaginationDetails() {
    if (this.gridApi) {
      this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
      this.tPage = this.gridApi.paginationGetTotalPages();

      this.sRecord =
        this.gridApi.paginationGetPageSize() *
        this.gridApi.paginationGetCurrentPage() +
        1;
      this.eRecord =
        this.gridApi.paginationGetPageSize() *
        this.gridApi.paginationGetCurrentPage() +
        this.gridApi.paginationGetPageSize();
      this.totalRecords = this.gridApi.paginationGetRowCount();
      this.eRecord =
        this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
    }
  }

  getCurrentPage(): boolean {
    if (this.cPage == 1) { // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.currentPageForTotalPage = Number(this.cPage);
    if (this.tPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  rppChanged(event: any) {
    this.cPage = 1;
    this.gridApi?.setGridOption(
      'paginationPageSize',
      Number(event.target.value),
    );
    this.updatePaginationDetails();
  }

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }

  goBack() {
    this.location.back();
  }
}